ValidationEngine = App.loadClass 'core::ValidationEngine'

class exports.RuppOrdersDialogCustomersHandler extends Handler

    init: () =>
        @layoutSelector = '#orders_steps_container'
        @layoutUrl = 'backend/grower/rupp-orders/load-layout-customers'

        @subHandlers =
            Licenses:
                class: 'grower::handlers/rupp_orders/RuppOrdersLicensesHandler'
        @dataLoaded = false
        @loadLayout()


    afterLoadLayout: (selector, response) =>
        if response.status?.type isnt 'success'
            return

        ths = this

        # Collapse / expand customer
        $('.orders_customers_container').delegate '.cust_header', 'click', () ->
            $(this).next().toggle()
            $(this).find('.header-icon').toggle()

        # Delete customer
        $('.orders_customers_container').delegate '.btn_cust_delete', 'click', (e) ->
            ths.parent.deleteFormData('customers', $(this).data('dynamic-id'))
            $(this).closest('.cust_header').next().remove().end().remove()
            ths.calculateBilling()
            e.stopPropagation()

        # Collapse all / expand all
        func = (e) ->
            for header in $('.cust_header')
                if ($(header).next().is(':visible')) is ($(this).attr('id') is 'collapse')
                    $(header).next().toggle()
                    $(header).find('.header-icon').toggle()
            $('.collapse_all').toggle()

        $('#collapse').bind 'click', func
        $('#expand').bind 'click', func

        # Load customer info
        $('.orders_customers_container').delegate '.sel_cust_name', 'change', () ->
            info = ths.taffyObjects['customers'](
                id:
                    '==': $(this).val()
            )

            curr = $(this)
            docontinue = true
            # Don't let the user select the same person multiple times
            # as a customer
            $('.orders_customers_container').find('.sel_cust_name').each () ->
                if not $(this).is(curr)
                    if $(this).val() is curr.val()
                        curr.val('')
                        docontinue = false

            if not docontinue
                return

            $(this).closest('.cust-info')
            .find('.txt_cust_address1').val(info.select('address1')).end()
            .find('.txt_cust_address2').val(info.select('address2')).end()
            .find('.txt_cust_city').val(info.select('city')).end()
            .find('.txt_cust_state').val(info.select('state')).end()
            .find('.txt_cust_zipcode').val(info.select('zipcode')).end()
            .find('.txt_cust_operation').val(info.select('rupp_operation')).end()
            .find('.txt_cust_phone').val(info.select('phone')).end()
            .find('.txt_cust_email').val(info.select('email')).end()
            ths.updateName(this)

            # Update the shipping address
            if $(this).data('dynamic-id') is 0 and ths.dataLoaded
                $('#customers_container .orders_customers_sidebar #address1').val(info.select('address1'))
                $('#customers_container .orders_customers_sidebar #address2').val(info.select('address2'))
                $('#customers_container .orders_customers_sidebar #city').val(info.select('city'))
                $('#customers_container .orders_customers_sidebar #state').val(info.select('state'))
                $('#customers_container .orders_customers_sidebar #zipcode').val(info.select('zipcode'))


        # Add customer
        @cust_id = 0
        $('#btn_add_customer').bind 'click', () ->
            cust_id = $(this).data('id')
            $(this).removeData('id')
            cust_id = ths.cust_id if not cust_id?

            remainder = Math.max(0, 100 - ths.calculateBilling(false))
            data = $('.add-cust-tmpl').render({ cust_id: cust_id, cust_billing: remainder })
            data = $($.parseHTML(data))
            data.find('.txt_cust_phone').mask('?999 999 9999')
            data.find('.txt_cust_zipcode').mask('?99999')


            # Set some data attributes on all the form elements so we can
            # know where to save their data
            data.find('.order-data').attr('data-dynamic-btn', '#btn_add_customer')
            data.find('.order-data').attr('data-dynamic-id', cust_id)
            data.find('.btn_cust_delete').attr('data-dynamic-id', cust_id)

            if parseInt(cust_id) is 0 # because coffeescript is STUPID!!!
                data.find('.btn_cust_delete').remove()
                data.find('.hdn-primary-cust').val('true')
            else
                data.find('#btn_licenses').remove()
                data.find('.txt_cust_phone, .txt_cust_email').removeClass('validate-required')

            data.appendTo('.orders_customers_container')

            ths.calculateBilling()
            ths.cust_id = parseInt(cust_id) + 1

        # Billing percent - click
        $('.orders_customers_container').delegate '.txt_cust_billing', 'click', (e) ->
            e.stopPropagation()

        # Billing percent - change
        $('.orders_customers_container').delegate '.txt_cust_billing', 'change', (e) ->
            $(this).val(Math.min(100, Math.max(0, $(this).val())))
            if $('.txt_cust_billing').length is 2 and ths.dataLoaded
                for elem in $('.txt_cust_billing')
                    if not $(elem).is(this)
                        $(elem).val(100 - $(this).val())
            ths.calculateBilling()

        # Datepicker
        $('#delivery_date').datepicker()
        $('#zipcode').mask('?99999')

        # Licenses
        $('.orders_customers_container').delegate '#btn_licenses', 'click', (e) =>
            dlg = @createSubHandler('Licenses')
            if dlg
                dlg.loadLayoutPostOptions =
                    'users_id': $(e.target).closest('.cust_header').next().find('.sel_cust_name').val()
                dlg.init()
            e.stopPropagation()

        # Sizes
        $('#btn_size').click (e) =>
            dlg = @createSubHandler('Sizes')
            if dlg
                dlg.init()

        # Weights
        $('#btn_weight').click (e) =>
            dlg = @createSubHandler('Weights')
            if dlg
                dlg.init()

        if @parent.editable
            # Handle validation
            @validator = new ValidationEngine()

            @validator.makeFormValidator 'customers', '#customers_container', '#customers_errors', (valid) =>
                @parent.gotoNext() if valid

            @validator.registerRule
                selector: '.validate-afterOrderDate'
                text: 'Delivery date must be after order date'
                func: (elem) ->
                    return Date.parse(elem.val()) > Date.parse($('.orders_customers_sidebar #order_date').val())

            @validator.registerRule
                selector: '.validate-isLTE100'
                text: 'Billing % must be 100% or less'
                func: (elem) ->
                    return parseInt(elem.val()) <= 100

            @validator.registerRule
                selector: '.validate-equals100'
                text: 'Total Billing % must equal 100'
                func: (elem) ->
                    return parseInt(elem.val()) is 100

            @validator.registerRule
                selector: '.validate-isInteger'
                text: 'Billing % must be an integer'
                func: (elem) ->
                    return parseInt(elem.val()) is parseFloat(elem.val())

            @validator.registerRule
                selector: 'select[name="sales_rep_fk"]'
                text: 'You must change the sales rep on this order'
                func: (elem) =>
                    data = response.data
                    return not data.require_rep_change or parseInt(data.orig_rep) isnt parseInt(elem.val())


        @parent._handleResize()

        # Finally, load all the form data
        @parent.loadFormData()

        @parent.dialog.find('.message_writer').message_writer( autoHide: false )


    calculateBilling: (update = true) =>
        sum = 0
        sum += parseInt($(e).val()) for e in $('.txt_cust_billing')

        if update
            $('input[name="total_billing_percent"]').val(sum)
        return sum


    updateName: (elem) =>
        ths = this
        $(elem).each () ->
            name = ths.taffyObjects['customers'](
                id:
                    '==': $(this).val()
            ).select('name')[0]
            if not name
                $(ths.layoutSelector).find('#btn_licenses').prop('disabled', true)
            else
                $(ths.layoutSelector).find('#btn_licenses').button('reset')
            name = '' if not name?
            $(this).closest('div.cust-info').prev().find('.cust_name').html(name)


    afterLoadData: () =>
        @updateName('.sel_cust_name')
        @calculateBilling()
        @dataLoaded = true
